module.exports = __webpack_public_path__ + "static/media/G1-19-Amazonas-Calouras-cod39.2c3dcb1d.png";